/**
 * Catalogue de RÉFÉRENCE (français) — la SOURCE de vérité des clés i18n.
 * `en.ts`/`es.ts` sont typés contre `Catalog` → toute clé manquante casse le build.
 * Interpolation : `{x}` remplacé par les params passés à `t(key, { x })`.
 * Pluriel : suffixes `.one` / `.other` (cf. `tp`).
 */
const fr = {
  // --- en-tête / shell ---
  "brand.aria": "Mondial 2026 — accueil",
  "brand.hosts": "Pays hôtes : États-Unis · Canada · Mexique",
  "mode.aria": "Mode d'affichage",
  "mode.dashboard": "Tableau de bord",
  "mode.projection": "Projection",
  "mode.sim": "Simulation",
  "mode.stats": "Statistiques",
  "mode.method": "Méthode",
  "mode.method.aria": "Comment les stats sont calculées",
  replay: "Rejouer",
  "replay.title": "Rejouer le déroulé des résultats",
  "theme.aria": "Basculer entre mode clair et mode sombre",
  "theme.title": "Clair / sombre",
  "refresh.title": "Rafraîchir maintenant",
  "lang.aria": "Langue",
  "rotate.hint": "Tournez votre téléphone en portrait pour une meilleure expérience",
  "rotate.dismiss": "Ignorer",
  "fresh.connecting": "connexion aux données…",
  "fresh.unavailable": "données indisponibles",
  "fresh.up": "à jour",
  "fresh.late": "en retard",
  "fresh.offline": "hors-ligne",
  "fresh.state": "Données : {state}",
  "banner.cached": "Données du {date} — rafraîchissement indisponible",
  "banner.degraded": "Données live indisponibles — affichage du calendrier de base",
  // --- pied de page ---
  "foot.source": "Source live",
  "foot.dataFrom": "données du {date}",
  "foot.lastCalc": "Dernier calcul",
  "foot.tz": "Horaires affichés dans votre fuseau",
  "foot.disclaimer":
    "Modèle statistique informatif — ne constitue pas un pronostic garanti. Drapeaux : flag-icons (jsDelivr).",
  // --- temps relatif / compte à rebours ---
  "ago.s": "il y a {n} s",
  "ago.min": "il y a {n} min",
  "ago.h": "il y a {n} h",
  "cd.imminent": "imminent",
  "cd.waiting": "en attente du direct",
  "cd.days": "dans {d} j {h} h",
  "cd.hours": "dans {h} h {m} min",
  "cd.mins": "dans {m} min {s} s",
  "cd.secs": "dans {s} s",
  // --- bande « Aujourd'hui » ---
  today: "Aujourd'hui",
  "today.short": "Auj.",
  "today.scrollAria": "Matchs (défilement horizontal)",
  "today.untilTomorrow": "jusqu'à demain 9h",
  "today.match.one": "{n} match",
  "today.match.other": "{n} matchs",
  "today.noMatch": "aucun match",
  "today.none": "Aucun match ce jour-là.",
  "today.choose": "Choisir un jour",
  // --- carte « En direct » (blocs pliables) ---
  "lf.stats": "Statistiques",
  "lf.lineups": "Compositions",
  "lf.lineupsNone": "Compositions non communiquées",
  // --- tours du tableau final ---
  "round.group": "Phase de groupes",
  "round.r32": "16es de finale",
  "round.r16": "8es de finale",
  "round.qf": "Quart de finale",
  "round.sf": "Demi-finale",
  "round.third": "Match pour la 3e place",
  "round.final": "Finale",
  // --- i18n sweep 28/06 : chaînes auparavant codées en dur (composants/fiches) ---
  "bracket.final": "FINALE",
  "bracket.round.qfShort": "Quart",
  "bracket.round.sfShort": "Demie",
  "bracket.thirdPlace": "3e PLACE",
  "bracket.title": "Tableau final",
  "clubs.col.assists": "Passes D",
  "clubs.col.assists.title": "Trier par passes décisives cumulées",
  "clubs.col.avgRating": "Note moy.",
  "clubs.col.avgRating.title": "Trier par note moyenne (clique une 2e colonne pour départager)",
  "clubs.col.club": "Club",
  "clubs.col.goals.title": "Trier par buts cumulés des joueurs du club",
  "clubs.col.players.title": "Trier par nombre de joueurs notés",
  "clubs.note": "Pour chaque club, on prend ses joueurs présents au Mondial : la NOTE est la moyenne de leur note de tournoi (chaque joueur compte une fois) ; BUTS et PASSES D sont leurs totaux cumulés en Coupe du monde. Seuls les clubs comptant au moins 3 joueurs notés sont classés. Clique un en-tête pour trier — une 2ᵉ colonne sert de départage (¹ primaire, ² secondaire). Survole une ligne pour ses meilleurs contributeurs.",
  "clubs.row.title": "{name} — détail par joueur · {tip}",
  "clubs.section.count": "note moyenne de leurs internationaux en Coupe du monde",
  "clubs.section.title": "Clubs au Mondial",
  "common.absent": "Absent",
  "common.asOf": "au",
  "common.assists": "passes",
  "common.assists.v2": "passes décisives",
  "common.avgAbbr": "moy",
  "common.champion": "champion",
  "common.close": "Fermer",
  "common.draw": "nul",
  "common.dribbles": "dribbles",
  "common.duels": "duels",
  "common.eliminated": "éliminé",
  "common.finished": "TERMINÉ",
  "common.goals": "buts",
  "common.halfTime": "Mi-temps",
  "common.halfTimeAbbr": "MT",
  "common.keyPasses": "passes clés",
  "common.live": "EN DIRECT",
  "common.loading": "chargement…",
  "common.loading.v2": "Chargement…",
  "common.match": "match",
  "common.matchesAbbr": "m.",
  "common.ordinal.first": "er",
  "common.ordinal.other": "e",
  "common.ordinal.suffix": "er / e",
  "common.penaltiesAbbr": "TAB",
  "common.penaltiesAbbr.v2": "tab",
  "common.player": "joueur",
  "common.players": "joueurs",
  "common.points": "points",
  "common.pos.attackers": "Attaquants",
  "common.pos.defenders": "Défenseurs",
  "common.pos.midfielders": "Milieux",
  "common.pos.others": "Autres",
  "common.postponed": "reporté",
  "common.rated": "noté",
  "common.suspended": "Suspendu",
  "common.tackles": "tacles",
  "common.top": "top",
  "common.upcoming": "À venir",
  "common.vs": "vs",
  "common.winAbbr": "V",
  "common.yearsOld": "ans",
  "elo.adjusted.title": "rating ajusté (forfaits déclarés)",
  "elo.avg.row": "Moyenne du tournoi",
  "elo.col.sort.title": "Trier par {label} (clique une 2e colonne pour départager les égalités)",
  "elo.col.value": "Valeur",
  "elo.delta.title": "évolution depuis le 11/06",
  "elo.note": "Formule World Football Elo Ratings (K = 60) · {n} équipe déjà bougée · Δ depuis l'avant-tournoi · Note = note d'équipe moyenne sur le tournoi · valeur d'effectif (Transfermarkt) · clique un en-tête pour trier — une 2ᵉ colonne sert de départage (¹ primaire, ² secondaire) ; une Note ou une Valeur ouvre le détail joueur par joueur · * rating ajusté.",
  "elo.note.btn.title": "Détail par joueur — note moyenne de compétition (sur {n} match noté)",
  "elo.section.count": "vivant · recalculé à chaque fin de match",
  "elo.section.title": "Classement Elo",
  "elo.value.btn.title": "Détail joueur par joueur + source de la valeur",
  "elo.value.millions": "{n} M€",
  "fiche.closeDetail": "Fermer le détail",
  "fiche.closeProfile": "Fermer la fiche",
  "fiche.country.attack.fair": "conforme à ses xG",
  "fiche.country.attack.for": "pour",
  "fiche.country.attack.over": "marque plus que ses xG",
  "fiche.country.attack.subtitle": "buts vs xG",
  "fiche.country.attack.title": "Efficacité offensive",
  "fiche.country.attack.under": "marque moins que ses xG",
  "fiche.country.conversionWord": "conversion",
  "fiche.country.defense.bad": "encaisse plus que les xG adverses",
  "fiche.country.defense.concededWord": "encaissé",
  "fiche.country.defense.fair": "conforme aux xG adverses",
  "fiche.country.defense.good": "encaisse moins que les xG adverses",
  "fiche.country.defense.oppXg": "xG adverses",
  "fiche.country.defense.prevented": "évités",
  "fiche.country.defense.subtitle": "encaissés vs xG adverses",
  "fiche.country.defense.title": "Solidité défensive",
  "fiche.country.dialogLabel": "Fiche pays",
  "fiche.country.lowSample": "peu de matchs, à confirmer",
  "fiche.country.over": "sur",
  "fiche.country.rendement": "Rendement :",
  "fiche.country.rendement.value": "valeur",
  "fiche.country.results": "Résultats",
  "fiche.country.squad.title": "Sélection",
  "fiche.country.squad.unavailable": "Sélection non disponible (chargée depuis l'archive en prod).",
  "fiche.country.tile.rank": "classement",
  "fiche.country.tile.squadValue": "valeur effectif",
  "fiche.country.value.fair": "à sa valeur",
  "fiche.country.value.over": "au-dessus de sa valeur",
  "fiche.country.value.under": "en-dessous de sa valeur",
  "fiche.country.xgDiff.conceded": "concédés",
  "fiche.country.xgDiff.created": "créés",
  "fiche.country.xgDiff.title": "Différentiel xG",
  "fiche.deserved.cell": "{xg} xG → {goals}",
  "fiche.deservedTitle": "Résultat mérité (xG)",
  "fiche.dominance": "Domination",
  "fiche.eventsLive": "Faits en direct",
  "fiche.eventsMatch": "Faits du match",
  "fiche.expectedGoalsModel": "Buts attendus (modèle)",
  "fiche.h2h.draws": "{d} nul",
  "fiche.h2h.empty": "Aucune confrontation enregistrée",
  "fiche.h2h.meetings": "{n} rencontre",
  "fiche.h2h.title": "Face-à-face",
  "fiche.h2h.winsTitle": "{w} victoire",
  "fiche.htScore": "MT {h}–{a}",
  "fiche.overlayAria": "Détail du match",
  "fiche.player.age": "{age} ans",
  "fiche.player.apps": "matchs",
  "fiche.player.avgRating": "note moy.",
  "fiche.player.dialogLabel": "Fiche joueur",
  "fiche.player.fallbackName": "Joueur",
  "fiche.player.lastMatch": "Dernier match",
  "fiche.player.matchByMatch": "Match par match",
  "fiche.player.metrics.cumTournament": "cumulé tournoi",
  "fiche.player.metrics.profile": "profil {pos}",
  "fiche.player.metrics.title": "Métriques",
  "fiche.player.metrics.vsPosAvg": "vs moyenne du poste",
  "fiche.player.noMatches": "Pas encore de match archivé pour ce joueur.",
  "fiche.player.noStats": "Pas de stats cette saison",
  "fiche.player.pos.attacker": "Attaquant",
  "fiche.player.pos.defender": "Défenseur",
  "fiche.player.pos.goalkeeper": "Gardien",
  "fiche.player.pos.midfielder": "Milieu",
  "fiche.player.ratingCurve.ariaLabel": "Évolution des notes du joueur",
  "fiche.player.ratingCurve.title": "Évolution des notes",
  "fiche.player.seasonAvg": "moy. saison",
  "fiche.player.unavailable": "Fiche indisponible",
  "fiche.player.vsOpp": "vs {opp}",
  "fiche.player.vsPosAvg": "vs moyenne {pos} du tournoi",
  "fiche.playerRatings.avgOn": "moyenne sur {n}",
  "fiche.playerRatings.avgOnRated": "moyenne sur {n} noté(s)",
  "fiche.playerRatings.dialogLabel": "Note d'équipe par joueur",
  "fiche.playerRatings.empty": "Aucune note de joueur archivée pour cette équipe (les notes apparaissent une fois les matchs joués).",
  "fiche.playerRatings.foot": "Note moyenne sur les matchs de Coupe du monde (notes par match API-Football) · triées par note décroissante · clique un nom pour la courbe match par match.",
  "fiche.playerRatings.subtitle": "Notes de compétition",
  "fiche.preMatch": "Avant-match",
  "fiche.probabilityDraw": "Probabilité — nul {draw}",
  "fiche.recentForm": "Forme récente",
  "fiche.squadValue.empty": "Détail joueur indisponible pour cette équipe.",
  "fiche.squadValue.footClickSource": "Cliquez {icon} pour la source.",
  "fiche.squadValue.footPrefix": "Valeurs Transfermarkt",
  "fiche.squadValue.footSum": "somme des {n} joueurs les plus chers (entrée du modèle « Elo + valeur »).",
  "fiche.squadValue.sourceTitle": "Source : Transfermarkt",
  "fiche.squadValue.subtitle": "Valeur d'effectif",
  "fiche.squadValue.viewOn": "Voir {name} sur Transfermarkt",
  "fiche.standing": "Classement",
  "fiche.statsLive": "Stats en direct",
  "fiche.statsMatch": "Stats du match",
  "fiche.teamRating.curve.ariaLabel": "Évolution de la note d'équipe match par match",
  "fiche.teamRating.curve.title": "Évolution de la note d'équipe",
  "fiche.teamRating.curve.trendTitle": "Tendance sur les derniers matchs",
  "fiche.teamRating.curveTrend.down": "en baisse",
  "fiche.teamRating.curveTrend.flat": "stable",
  "fiche.teamRating.curveTrend.up": "en hausse",
  "fiche.teamRating.tagTitle": "Note d'équipe — moyenne pondérée par les minutes ({n} joueurs notés)",
  "fiche.teamRating.trend.down": "forme en baisse",
  "fiche.teamRating.trend.flat": "forme stable",
  "fiche.teamRating.trend.up": "forme en hausse",
  "fiche.teamRating.trendTitleSuffix": "(note d'équipe récente)",
  "fiche.tournamentXi": "Équipe type du tournoi",
  "groups.legend.direct": "qualifiés directs",
  "groups.legend.live": "score en cours intégré",
  "groups.legend.thirds": "3e en zone de repêchage (rang parmi les 3es)",
  "groups.liveScoreTitle": "Score en cours intégré",
  "groups.playedCount": "{played}/6 j.",
  "groups.provisionalTitle": "Classement provisoire (match en cours)",
  "groups.thirdRankBadge": "3e&nbsp;#{n}",
  "groups.thirdRankTitle": "Rang parmi les 3es",
  "lb.apps": "{n} m",
  "lb.col.assists": "Passeurs",
  "lb.col.ratings": "Notes",
  "lb.col.scorers": "Buteurs",
  "lb.empty": "Aucun pour l'instant",
  "lb.section.count": "depuis le début du tournoi",
  "lb.section.title": "Classements joueurs",
  "lb.unit.assist.one": "passe",
  "lb.unit.goal.one": "but",
  "lf.assistBy": "passe {player}",
  "lf.awaitingLiveData": "en attente des données live",
  "lf.event.goal": "But",
  "lf.event.red": "Carton rouge",
  "lf.event.subst": "Remplacement",
  "lf.event.yellow": "Carton jaune",
  "lf.expandMiniTitle": "{home} – {away} — afficher en grand (partager l'espace)",
  "lf.expectedGoals": "Buts attendus",
  "lf.groupMatchday": "Groupe {group} · Journée {matchday}",
  "lf.groupMatchdayAbbr": "Groupe {group} · J{matchday}",
  "lf.halfTimeScore": "Mi-temps {h}–{a}",
  "lf.inProgress": "en cours",
  "lf.kickoffAt": "Coup d'envoi {time}",
  "lf.kickoffPassed": "COUP D'ENVOI DÉPASSÉ",
  "lf.kickoffShort": "Coup d'envoi",
  "lf.kickoffWaitingLive": "Coup d'envoi {kick} · en attente des données live",
  "lf.kickoffYourLocalTime": "Coup d'envoi {kick} · votre heure locale",
  "lf.lineupsNotProvided": "Compositions non communiquées",
  "lf.lineupsTitle": "Compositions",
  "lf.lineupsUpper": "COMPOSITIONS",
  "lf.minimizeMatch": "Réduire ce match en mini-carte",
  "lf.modelPrediction": "prédiction du modèle",
  "lf.nextMatch": "PROCHAIN MATCH",
  "lf.nextMiniAria": "Prochain match — survoler ou activer pour la prédiction avant-match",
  "lf.nextShort": "PROCHAIN",
  "lf.opponentsUnknown": "Adversaires pas encore connus — prédiction à venir.",
  "lf.penaltiesScore": "TAB {h}–{a}",
  "lf.predictionDraw": "Prédiction — nul {draw}",
  "lf.predictionDrawLabel": "Prédiction — nul {pct}",
  "lf.strengthElo": "Force (Elo)",
  "lf.yourLocalTime": "votre heure locale",
  "lineup.absentUncertain": "absent/incertain",
  "lineup.captain": "capitaine",
  "lineup.startingLineupsAria": "Compositions de départ",
  "lineup.substitutes": "Remplaçants",
  "method.elo": "Ratings World Football Elo Ratings réels au 11/06/2026 (eloratings.net), mis à jour après chaque match terminé (K = 60, avantage hôte +100, TAB compté comme nul). * Ratings ajustés pour forfaits déclarés : NED −22, BRA −10, CAN −12.",
  "method.footer": "<b>Précautions :</b> à l'échelle d'une Coupe du monde (1 à 7 matchs), les écarts aux xG sont surtout dus au <b>hasard</b> — ces métriques <b>décrivent</b> ce qui s'est passé, elles ne <b>prédisent</b> pas. Les seuils entre parenthèses (≥ 3 tirs, ≥ 5 duels, xG ≥ 3…) sont des garde-fous : en dessous, la stat est masquée ou son verdict n'est pas coloré. L'xG provient d'un seul modèle (API-Football).",
  "method.goals": "Buts attendus : mapping Elo→Poisson du modèle d'origine (continuité v2), avantage hôtes +90 côté prédiction. Égalité en phase finale : prolongation (λ×⅓) puis tirs au but selon la qualité des gardiens (EA FC 26, {n}/48 équipes couvertes, 50/50 sinon — les études récentes ne mesurent pas d'avantage systématique).",
  "method.intro": "Chaque chiffre affiché est soit <b>récupéré</b> auprès d'une source de données, soit <b>calculé</b> par l'application à partir de ces données — jamais généré par une IA. Tout est <b>déterministe</b> et reproductible. Légende des sources :",
  "method.legend.apiFootball": "<b>API-Football</b> — stats de match, d'équipe et de joueur",
  "method.legend.appCalc": "<b>Calcul de l'app</b> — dérivé des stats brutes (formules ci-dessous)",
  "method.legend.otherFeeds": "<b>Autres flux</b> — Transfermarkt (valeur), eloratings (Elo), FIFA (classement officiel)",
  "method.legend.simulation": "<b>Simulation</b> — Monte-Carlo Elo–Poisson (seedé, reproductible)",
  "method.row.bestThirds.d": "les 8 repêchés : pts → diff → buts → classement FIFA → tirage. Temps réel (⏱)",
  "method.row.bestThirds.s": "Meilleurs 3èmes",
  "method.row.bestThirds.w": "section dédiée",
  "method.row.bestXiClubs.d": "meilleur XI par note ; note moyenne regroupée par club",
  "method.row.bestXiClubs.s": "Équipe-type · Notes par club",
  "method.row.bestXiClubs.w": "« Classements », section clubs",
  "method.row.citiesByPlace.d": "la position de groupe fixe le créneau R32 → tout le parcours / stades en découle",
  "method.row.citiesByPlace.s": "Villes selon la place",
  "method.row.citiesByPlace.w": "mode Projection",
  "method.row.conversion.d": "buts ÷ tirs (si ≥ 3 tirs)",
  "method.row.conversion.w": "fiche joueur « Métriques »",
  "method.row.cornersFoulsEtc.d": "comptages bruts du match",
  "method.row.cornersFoulsEtc.s": "Corners · Fautes · Hors-jeu · Cartons · Arrêts",
  "method.row.defSolidity.d": "buts encaissés ÷ xG adverses (même calcul, sémantique inversée)",
  "method.row.deservedResult.d": "buts − xG : ≥ +0,8 « sur-performe » · ≤ −0,8 « gâche » · sinon « fidèle »",
  "method.row.deservedResult.s": "Résultat mérité",
  "method.row.domination.d": "indice pondéré : xG·0,35 + possession·0,25 + tirs·0,20 + cadrés·0,10 + corners·0,10 → part par camp (0–100)",
  "method.row.domination.w": "fiche match",
  "method.row.elo.d": "force d'une équipe. Rn = Ro + K·G·(W − We), K = 60 en phase finale ; recalculé après chaque match terminé",
  "method.row.elo.s": "Elo (+ Δ)",
  "method.row.elo.w": "Classement Elo, fiche pays, carte live",
  "method.row.fifaRank.d": "rang mondial officiel (instantané committé, figé pendant la CdM)",
  "method.row.fifaRank.s": "Classement FIFA",
  "method.row.fifaRank.w": "dernier critère de départage (interne)",
  "method.row.goalsAssists.d": "production offensive",
  "method.row.goalsAssists.s": "Buts · passes décisives",
  "method.row.groupStandings.d": "départage FIFA Art. 13 : confrontation directe (pts/diff/buts) → diff. générale → buts → fair-play → classement FIFA → tirage seedé. ⏱ si un score live est intégré",
  "method.row.groupStandings.s": "Classements de groupe",
  "method.row.groupStandings.w": "grille des groupes",
  "method.row.h2h.d": "bilan victoires-nuls-défaites + liste des confrontations passées",
  "method.row.h2h.s": "Face-à-face (H2H)",
  "method.row.idem.w": "idem",
  "method.row.injuries.d": "indisponibilités (rafraîchies 1×/jour)",
  "method.row.injuries.s": "Blessures / absences",
  "method.row.injuries.w": "badge mini-terrain, entrée du modèle",
  "method.row.lineups.d": "onze de départ + formation (ex. 4-3-3) + entraîneur",
  "method.row.lineups.w": "fiche match → mini-terrain",
  "method.row.matchEvents.d": "buts, cartons et remplacements horodatés (minute + joueur)",
  "method.row.matchEvents.w": "fiche match « Faits » + flux live",
  "method.row.offEfficiency.d": "buts ÷ xG cumulés. Verdict (sur/sous-performe) coloré seulement si xG cumulé ≥ 3 (sinon : variance)",
  "method.row.passAcc.d": "% de passes réussies sur le match",
  "method.row.passAcc.s": "Passes réussies",
  "method.row.per90.d": "total ÷ minutes × 90",
  "method.row.per90.s": "G+A / 90 · Passes clés / 90 · Tacles / 90",
  "method.row.possession.d": "% du temps avec le ballon",
  "method.row.possession.s": "Possession",
  "method.row.possession.w": "carte live + fiche match",
  "method.row.possibleOpponents.d": "distribution des occupants du créneau adverse dans la simulation",
  "method.row.possibleOpponents.s": "Adversaires possibles par tour",
  "method.row.possibleOpponents.w": "mode Projection (arbre)",
  "method.row.prediction.d": "proba 1-N-2 (Elo → Poisson) + Elo + xG du modèle",
  "method.row.prediction.s": "Prédiction avant-match",
  "method.row.prediction.w": "carte « prochain match » (survol), fiche match",
  "method.row.probabilities.d": "fréquence sur une simulation Monte-Carlo seedée et conditionnable",
  "method.row.probabilities.s": "Probabilités (titre / finale / qualif…)",
  "method.row.probabilities.w": "« Probabilités », mode Projection",
  "method.row.qualifConditions.d": "énumération de tous les résultats V/N/D des matchs restants + règle de départage (confrontation directe, puis différence de buts)",
  "method.row.qualifConditions.s": "Conditions de qualification",
  "method.row.qualifConditions.w": "modale Projection",
  "method.row.ratesPct.d": "moyenne / taux de réussite",
  "method.row.ratesPct.s": "% passes · Duels gagnés % (≥5) · Dribbles % (≥3)",
  "method.row.rating.d": "note de match du fournisseur (0–10)",
  "method.row.rating.w": "fiche joueur « Match par match », survol sur le mini-terrain",
  "method.row.scoreMinuteStatus.d": "résultat live ou final, minute jouée (+ arrêts de jeu en direct, ex. 90+4), état (à venir / en direct / mi-temps / terminé)",
  "method.row.scoreMinuteStatus.s": "Score · minute · statut",
  "method.row.scoreMinuteStatus.w": "bande Aujourd'hui, carte En direct, fiche match",
  "method.row.scorersAssists.d": "tops agrégés de l'archive",
  "method.row.scorersAssists.s": "Buteurs · Passeurs · Notes",
  "method.row.scorersAssists.w": "« Classements »",
  "method.row.shots.d": "total des tirs, tirs cadrés, tirs bloqués",
  "method.row.shots.s": "Tirs · cadrés · contrés",
  "method.row.shotsPassesPct.d": "volume et précision",
  "method.row.shotsPassesPct.s": "Tirs / cadrés · passes / clés · % passes",
  "method.row.squadValue.d": "somme de la valeur marché du top-23 (rafraîchie 1×/jour)",
  "method.row.squadValue.w": "fiche pays, classement Elo, modale valeur (détail par joueur)",
  "method.row.tacklesDuels.d": "activité défensive et percussion",
  "method.row.tacklesDuels.s": "Tacles · duels (gagnés/total) · dribbles (réussis/tentés)",
  "method.row.teamEfficiency.d": "sur-performance offensive (buts − xG) / défensive (encaissés − xGA). Équipes à xG ≥ 3 seulement ; descriptif, pas une hiérarchie de talent",
  "method.row.teamRating.d": "Σ(note · minutes) ÷ Σ(minutes) ; tendance = pente des ~4 dernières notes (seuil ±0,15)",
  "method.row.teamRating.s": "Note d'équipe + tendance ↗/↘",
  "method.row.teamRating.w": "pastille carte live, courbe fiche pays",
  "method.row.vsPositionAvg.d": "(valeur du joueur ÷ moyenne du tournoi à son poste − 1) × 100. Tacles/90 = un volume → montré mais non coloré bon/mauvais",
  "method.row.vsPositionAvg.w": "idem (grille ordonnée par poste)",
  "method.row.xg.d": "somme des probabilités de but des occasions (modèle du fournisseur)",
  "method.row.xg.s": "xG (buts attendus)",
  "method.row.xgDiff.d": "Σ(xG créés − xG concédés) — la mesure la plus robuste à petit échantillon",
  "method.row.yield.d": "rang Elo vs rang de valeur ; écart ≥ 4 places → joue « au-dessus / en-dessous de sa valeur »",
  "method.row.yield.s": "Rendement",
  "method.sec.calcMatch.title": "Métriques calculées — match",
  "method.sec.calcPlayer.note": "Affichées seulement au-dessus d'un minimum de volume (indiqué entre parenthèses) ; en dessous, masquées.",
  "method.sec.calcPlayer.title": "Métriques calculées — joueur (cumulé tournoi)",
  "method.sec.calcTeam.title": "Métriques calculées — équipe (cumulé tournoi)",
  "method.sec.context.title": "Contexte équipe & joueur",
  "method.sec.modelProjection.title": "Modèle & projection",
  "method.sec.playerMatch.title": "Stats d'un joueur par match",
  "method.sec.rawMatch.title": "Données brutes d'un match",
  "method.sec.standings.title": "Classements du tournoi",
  "method.sec.teamMatch.note": "Affichées en barres domicile / extérieur ; au survol, un graphe d'évolution dans le temps.",
  "method.sec.teamMatch.title": "Stats d'équipe par match",
  "method.standings": "Classements : règlement FIFA 2026 (confrontations directes d'abord) ; fair-play non modélisable depuis les scores ; dernier critère : classement Elo puis tirage au sort seedé 🎲. Simulation Monte Carlo dans un Web Worker, seedée et reproductible.",
  "method.summary": "Méthodologie",
  "method.table.head.definition": "Définition",
  "method.table.head.source": "Source",
  "method.table.head.stat": "Stat",
  "method.table.head.where": "Où",
  "method.title": "Méthode — comment sont calculées les stats",
  "probs.metaBrowser": "navigateur · {ms} ms",
  "probs.metaDraws": "{n} tirages",
  "probs.metaSeed": "seed {seed}",
  "probs.metaServer": "serveur (poussé)",
  "probs.modelTag": "modèle Elo–Poisson · Monte Carlo",
  "probs.preBelowThreshold": "< 0,3 % avant-tournoi",
  "probs.preLabelBelow": "< 0,3 %",
  "probs.preTournamentTitle": "Avant-tournoi : {pct} %",
  "probs.rowTitle": "{team} — avant-tournoi {preLabel}",
  "probs.running": "Simulation en cours…",
  "probs.title": "Probabilités de titre",
  "probs.waiting": "En attente de la première simulation…",
  "proj.champion": "Champion {pct}",
  "proj.computingMc": "Calcul du Monte Carlo…",
  "proj.cond.bestThird": " (meilleur 3ᵉ)",
  "proj.cond.bothQualify": "si {team} et {opp} se qualifient jusqu'ici",
  "proj.cond.dialogAria": "Conditions de l'affrontement",
  "proj.cond.if": "si {cond1} et {cond2}",
  "proj.cond.introDeep": "Le parcours et les scores possibles pour que {team} et {opp} se croisent en {round}.",
  "proj.cond.introR32": "Toutes les combinaisons de résultats encore à jouer qui réalisent ce 16ᵉˢ.",
  "proj.cond.koNote": "Puis {team} et {opp} remportent chacun leurs tours de KO précédents ({rounds}) pour se croiser en {round}.",
  "proj.cond.ofGroup": "du groupe {group}",
  "proj.cond.tieNote": "À égalité de points, le départage CdM 2026 regarde d'abord la confrontation directe entre les équipes concernées, puis la différence de buts générale, puis les buts marqués — c'est pourquoi le score d'un match peut faire basculer le classement d'une autre équipe.",
  "proj.cond.title": "Conditions — {team} vs {opp} · {round}",
  "proj.cta.continue": "Continuer",
  "proj.cta.editScores": "Modifier mes scores",
  "proj.cta.nextRound": "Passer au prochain tour",
  "proj.cta.project": "Projeter avec mes scores",
  "proj.lessThan1pct": "< 1 %",
  "proj.line.conditionsTitle": "Conditions pour affronter {opp}",
  "proj.match.awayScoreAria": "Score extérieur",
  "proj.match.homeScoreAria": "Score domicile",
  "proj.match.liveTitle": "en direct",
  "proj.match.playedTitle": "match joué",
  "proj.modal.finish": "Terminer",
  "proj.modal.finishRound": "Terminer ce tour",
  "proj.modal.hint": "Renseigne les scores que tu imagines : le parcours et les % de ton équipe se recalculent aussitôt.",
  "proj.modal.reset": "Réinitialiser",
  "proj.modal.resetN": "Réinitialiser ({n})",
  "proj.modal.stepCount": "Tour {i} / {n}",
  "proj.modal.tiebreakBody": " (CdM 2026) : 1) confrontation directe — points, diff. de buts, buts marqués ; 2) diff. de buts générale ; 3) buts marqués ; 4) fair-play (cartons) ; 5) classement FIFA.",
  "proj.modal.tiebreakTitle": "Départage à égalité de points",
  "proj.opening": "Ouverture de la projection…",
  "proj.outcome.awayWins": "{away} bat {home}",
  "proj.outcome.draw": "{home}–{away} : nul",
  "proj.outcome.homeWins": "{home} bat {away}",
  "proj.path.heading": "Parcours probable",
  "proj.path.title": "Titre",
  "proj.path.undetermined": "parcours encore indéterminé",
  "proj.pending.decidedBy": "décidé par : {parts}",
  "proj.pending.group": "gr. {group} : {matches}",
  "proj.picker.label": "Projeter",
  "proj.picker.model": "modèle Elo + valeur",
  "proj.picker.recalc": "· recalcul…",
  "proj.place.1": "1ᵉʳ",
  "proj.place.2": "2ᵉ",
  "proj.place.3": "3ᵉ",
  "proj.pos.bestThird": "meilleur 3ᵉ",
  "proj.pos.heading": "Vos villes changent selon votre place au groupe {group}",
  "proj.pos.variableSlot": "· créneau variable",
  "proj.preparing": "Préparation…",
  "proj.qualFallback.head": "{team} qualifié du groupe {group}",
  "proj.r32.whichResults": "Quels résultats rendent ce 16ᵉˢ possible ?",
  "proj.round.final": "Finale",
  "proj.round.qf": "Quarts de finale",
  "proj.round.r16": "8ᵉˢ de finale",
  "proj.round.r32": "16ᵉˢ de finale",
  "proj.round.sf": "Demi-finales",
  "proj.short.qf": "Quarts",
  "proj.short.r16": "8es",
  "proj.short.r32": "16es",
  "proj.short.sf": "Demies",
  "proj.solve.gdDeficit": "{rival} a {buts} de différence de buts d'avance → {me} doit combler ce retard en gagnant d'autant plus largement que lui",
  "proj.solve.gdEqual": "{me} et {rival} ont la même différence de buts → celui qui gagne le plus largement passe devant",
  "proj.solve.gdLead": "{me} a déjà {buts} de différence de buts d'avance sur {rival} → il reste devant en gardant cet avantage",
  "proj.solve.goalOther": "{n} buts",
  "proj.solve.h2hDraw": "confrontation directe nulle → on passe à la différence de buts : {lead}",
  "proj.solve.h2hLoss": "{rival} a gagné la confrontation directe → il faudrait que {me} prenne l'avantage autrement",
  "proj.solve.h2hWin": "{me} l'a emporté en confrontation directe → il termine devant {rival} (1ᵉʳ critère de départage, c'est réglé)",
  "proj.solve.head": "{team} {place} du groupe {group}",
  "proj.solve.more": "+ {n} autre(s)",
  "proj.solve.none": "Aucune combinaison ne le permet.",
  "proj.solve.settledNo": "✗ plus possible (groupe terminé)",
  "proj.solve.settledOk": "✓ déjà acquis (groupe terminé)",
  "proj.solve.tiedWith": "→ à égalité de points avec {rival}, {txt}",
  "proj.solve.tooMany": "Trop de matchs encore à jouer pour lister les combinaisons.",
  "proj.standings.gdTitle": "différence de buts",
  "proj.standings.gfTitle": "buts pour",
  "proj.standings.playedTitle": "joués",
  "proj.toggle.absences": "absents",
  "proj.toggle.absTitle": "Retranche des Elo selon les absents (blessés/suspendus). Expérimental, plafonné à ±{cap}.",
  "proj.toggle.exp": "exp.",
  "proj.toggle.form": "forme",
  "proj.toggle.formTitle": "Ajuste les Elo selon la forme récente (note d'équipe). Expérimental, plafonné à ±{cap}.",
  "proj.tree.heading": "Arbre du parcours probable",
  "proj.tree.subhead": "16ᵉˢ en onglets · les tours suivants suivent l'adversaire choisi",
  "proj.tree.undetermined": "Parcours encore indéterminé.",
  "proj.wizard.opponentIn": "Adversaire en {round}",
  "proj.wizard.yourPlacement": "Placement de ton équipe",
  "replay.groupPhaseDone": "Phase de groupes terminée",
  "replay.groupPhaseDoneToBracket": "Phase de groupes terminée — vers le tableau",
  "replay.pauseAria": "Pause",
  "replay.pauseResumeTitle": "Pause / reprise",
  "replay.resumeAria": "Reprendre",
  "replay.resuming": "Reprise des résultats…",
  "replay.skipToLive": "Aller au direct",
  "replay.speedTitle": "Accélérer",
  "replay.toBracket": "Passer au tableau",
  "sim.championTitle": "Champion du monde 2026 (simulation)",
  "sim.footer.champion": "Champion : {code}. Drapeaux : flag-icons (jsDelivr).",
  "sim.footer.deterministic": "scénario le plus probable, déterministe",
  "sim.footer.model": "Modèle Elo–Poisson, {ratings}. Ce n'est pas un pronostic garanti.",
  "sim.footer.oneOfMany": "Une réalisation parmi des millions — {tail}",
  "sim.footer.relaunch": "relancez pour un autre tirage",
  "sim.intro": "Le modèle déroule un tournoi complet — comme un vrai tirage au sort. Choisissez le modèle, lancez, regardez le champion se dessiner.",
  "sim.label.fixedCount": "({n} figés)",
  "sim.label.ratings": "Notes : {value}",
  "sim.label.scenario": "Scénario : {value}",
  "sim.label.shootout": "TAB : {value}",
  "sim.label.startFrom": "Départ : {value}",
  "sim.newDraw": "Nouveau tirage",
  "sim.ratings.legacy": "Elo legacy",
  "sim.ratings.real": "Elo réel",
  "sim.ratings.value": "Elo + valeur",
  "sim.replay": "Rejouer",
  "sim.replayScenario": "Rejouer ce scénario",
  "sim.runnerUp": "Finaliste",
  "sim.scenario.modal": "Le plus probable",
  "sim.scenario.random": "Aléatoire",
  "sim.scenarioFr.modal": "le plus probable",
  "sim.scenarioFr.random": "aléatoire",
  "sim.seg.scenario": "Scénario",
  "sim.seg.startFrom": "Départ",
  "sim.shootout.gk": "Gardiens",
  "sim.startFr.fromReal": "depuis le réel",
  "sim.startFr.scratch": "tournoi complet",
  "sim.startFrom.fromReal": "Depuis le réel",
  "sim.startFrom.scratch": "Tournoi complet",
  "sim.tabFr.gk": "gardiens",
  "sim.thirdPlace": "3e place",
  "sim.title": "Simulation du tournoi",
  "stats.col.apps.title": "matchs joués (au moins une minute)",
  "stats.col.assists.abbr": "PD",
  "stats.col.assists.title": "passes décisives (dernière passe avant un but)",
  "stats.col.cards": "Cartons",
  "stats.col.cards.group.title": "total cartons jaunes / rouges dans le groupe",
  "stats.col.cards.match.title": "total des cartons du match (jaunes + rouges)",
  "stats.col.cards.team.title": "total cartons jaunes / rouges reçus",
  "stats.col.corners.abbr": "Cor",
  "stats.col.corners.group.title": "total des corners obtenus dans le groupe",
  "stats.col.corners.team.title": "total des corners obtenus",
  "stats.col.date": "Date",
  "stats.col.date.title": "date et heure du coup d'envoi (votre fuseau horaire)",
  "stats.col.diff.abbr": "Diff",
  "stats.col.diff.title": "différence de buts (marqués − encaissés)",
  "stats.col.duelWinPct.abbr": "Duels%",
  "stats.col.duelWinPct.title": "pourcentage de duels gagnés (au sol et aériens)",
  "stats.col.elo": "Elo",
  "stats.col.elo.title": "force de l'équipe (World Football Elo), réactualisée après chaque match",
  "stats.col.goals": "Buts",
  "stats.col.goals.abbr": "B",
  "stats.col.goals.group.title": "total des buts marqués dans le groupe",
  "stats.col.goals.match.title": "total des buts du match (deux équipes)",
  "stats.col.goals.player.title": "buts marqués",
  "stats.col.goalsAgainst.abbr": "BC",
  "stats.col.goalsAgainst.title": "buts contre : buts encaissés",
  "stats.col.goalsFor.abbr": "BP",
  "stats.col.goalsFor.title": "buts pour : buts marqués",
  "stats.col.gpm.abbr": "B/m",
  "stats.col.gpm.title": "buts par match (moyenne) dans le groupe",
  "stats.col.group": "Groupe",
  "stats.col.group.title": "groupe de la phase de poules (✓ = ses 6 matchs sont terminés). Clic = filtrer les équipes",
  "stats.col.keyPasses.abbr": "PC",
  "stats.col.keyPasses.title": "passes clés : passes amenant directement un tir",
  "stats.col.match": "Match",
  "stats.col.match.title": "clic = fiche match (compositions, faits, stats)",
  "stats.col.minutes.abbr": "Min",
  "stats.col.minutes.player.title": "minutes jouées sur le tournoi (cumul)",
  "stats.col.minutes.team.title": "minutes jouées — 90/match (120 avec prolongation) + arrêts de jeu : status.extra en direct, sinon estimés en sommant le temps additionnel de chaque période d'après les évènements (la source ne donne pas le total)",
  "stats.col.passPct.abbr": "%P",
  "stats.col.passPct.match.title": "% de passes réussies de chaque équipe, dans l'ordre du match (équipe de gauche – équipe de droite)",
  "stats.col.passPct.player.title": "% de passes réussies suivi du NOMBRE total de passes tentées sur lequel il porte — ex. 90%/230 (un % sur peu de passes est peu significatif)",
  "stats.col.passPct.team.title": "% de passes réussies de l'équipe (agrégé sur tous ses joueurs) suivi du NOMBRE total de passes tentées sur lequel il porte — ex. 86%/4200 ; alimenté en production",
  "stats.col.played.abbr": "J",
  "stats.col.played.group.title": "matchs joués sur les 6 du groupe",
  "stats.col.played.team.title": "matchs joués",
  "stats.col.player.title": "clic = fiche joueur (stats du tournoi, courbe de notes)",
  "stats.col.points.abbr": "Pts",
  "stats.col.points.title": "points en phase de groupes (victoire 3, nul 1, défaite 0)",
  "stats.col.pos": "Poste",
  "stats.col.pos.title": "poste : Gardien / Déf(enseur) / Mil(ieu) / Att(aquant)",
  "stats.col.poss.abbr": "Poss",
  "stats.col.poss.match.title": "possession du ballon (%) de chaque équipe, dans l'ordre du match",
  "stats.col.possession.abbr": "Poss%",
  "stats.col.possession.title": "possession moyenne du ballon (% du temps de jeu)",
  "stats.col.rating": "Note",
  "stats.col.rating.title": "note moyenne du joueur sur le tournoi (0–10, fournisseur)",
  "stats.col.shots": "Tirs",
  "stats.col.shots.group.title": "total des tirs tentés dans le groupe",
  "stats.col.shots.match.title": "tirs cadrés / total des tirs de chaque équipe, dans l'ordre du match (ex. 5/12–2/8)",
  "stats.col.shots.player.title": "tirs cadrés / total des tirs tentés sur le tournoi (ex. 5/12)",
  "stats.col.shots.team.title": "tirs cadrés / total des tirs tentés (ex. 42/118)",
  "stats.col.stage": "Tour",
  "stats.col.stage.title": "tour de la compétition (phase de groupes ou élimination directe)",
  "stats.col.team": "Équipe",
  "stats.col.team.title": "clic = fiche pays (sélection, résultats, Elo, valeur)",
  "stats.col.xg.group.title": "buts attendus cumulés : qualité totale des occasions créées (modèle du fournisseur)",
  "stats.col.xg.match.title": "buts attendus (xG) de chaque équipe, dans l'ordre du match — qui méritait de marquer face au score",
  "stats.col.xg.team.title": "buts attendus créés : qualité cumulée des occasions de l'équipe (modèle du fournisseur)",
  "stats.col.xga.title": "buts attendus concédés : qualité des occasions laissées à l'adversaire",
  "stats.col.xgaHead": "xGA",
  "stats.col.xgHead": "xG",
  "stats.empty.waiting": "En attente des données…",
  "stats.filter.allGroups": "Tous les groupes",
  "stats.filter.allStages": "Tous les tours",
  "stats.filter.byGroup.aria": "Filtrer par groupe",
  "stats.filter.byStage.aria": "Filtrer par tour",
  "stats.filter.group.option": "Groupe {g}",
  "stats.filter.groupStage": "Phase de groupes",
  "stats.footer.method.link": "Méthode",
  "stats.footer.note": "Groupes, équipes et matchs : agrégés en direct depuis le flux (score en cours inclus, ⏱). Joueurs : agrégat serveur, rafraîchi périodiquement. Définitions : onglet Méthode.",
  "stats.footerNote": "Groupes, équipes et matchs : agrégés en direct depuis le flux (score en cours inclus, ⏱). Joueurs : agrégat serveur, rafraîchi périodiquement. Définitions : onglet ",
  "stats.graph.ariaLabel": "Évolution de {label} au fil du match",
  "stats.graph.buildingSub": "un relevé toutes les ~30 s — elle apparaît dans un instant",
  "stats.graph.buildingTitle": "Courbe en cours de construction",
  "stats.graph.unavailableSub": "match déjà terminé au lancement du suivi — pas d'historique rétroactif",
  "stats.graph.unavailableTitle": "Évolution indisponible",
  "stats.group.cell": "Groupe {group}",
  "stats.group.done.title": "groupe terminé",
  "stats.group.row.title": "Filtrer les équipes du groupe {group}",
  "stats.live.title": "match en cours",
  "stats.liveNow": "{n} en direct ⏱",
  "stats.metric.conversion": "Conversion",
  "stats.metric.dribblePct": "Dribbles réussis",
  "stats.metric.duelWinPct": "Duels gagnés",
  "stats.metric.gaPer90": "G+A / 90",
  "stats.metric.keyPassesPer90": "Passes clés / 90",
  "stats.metric.passAcc": "% passes",
  "stats.metric.tacklesPer90": "Tacles / 90",
  "stats.pill.corners": "corners",
  "stats.pill.goalsPerMatch": "buts / match",
  "stats.pill.redCards": "cartons rouges",
  "stats.pill.shots": "tirs",
  "stats.pill.xgTotal": "xG total",
  "stats.pill.yellowCards": "cartons jaunes",
  "stats.players.empty": "Classements joueurs indisponibles ici (alimentés par l'archive en production, au prochain agrégat).",
  "stats.search.placeholder": "Chercher un joueur…",
  "stats.section.groups": "Groupes",
  "stats.section.groups.hint": "clic sur un groupe → filtre les équipes",
  "stats.section.matches": "Matchs",
  "stats.section.players": "Joueurs",
  "stats.section.teams": "Équipes",
  "stats.shotsOnAbbr": "cad.",
  "stats.stage.group": "Groupe · J{md}",
  "stats.statMeta.blocked": "Tirs contrés",
  "stats.statMeta.corners": "Corners",
  "stats.statMeta.fouls": "Fautes",
  "stats.statMeta.offsides": "Hors-jeu",
  "stats.statMeta.red": "Cartons rouges",
  "stats.statMeta.saves": "Arrêts",
  "stats.statMeta.shotsOnTarget": "Tirs cadrés",
  "stats.statMeta.xg": "Buts attendus (xG)",
  "stats.statMeta.yellow": "Cartons jaunes",
  "stats.title": "Statistiques de la Coupe du monde",
  "teff.caveat": "Descriptif : l'écart aux xG reste sensible au hasard sur peu de matchs — pas une hiérarchie de talent.",
  "teff.col.attack": "Sur-performance offensive",
  "teff.col.defense": "Sur-performance défensive",
  "teff.main.conceded": "{n} enc.",
  "teff.main.goals": "{n} but",
  "teff.section.count": "buts vs xG sur le tournoi",
  "teff.section.title": "Efficacité des équipes",
  "thirds.col.goalDiff": "±",
  "thirds.col.group": "Gr.",
  "thirds.criteria": "Critères : points, différence de buts, buts marqués, classement FIFA, tirage 🎲.",
  "thirds.liveNote": "score en cours intégré (provisoire).",
  "thirds.subtitle": "repêchés pour les 16es",
  "thirds.title": "Les 8 meilleurs 3es",
  "stats.ev.inMatch": "Évolution minute par minute",
  "stats.ev.perMatch": "Match par match du tournoi",
  "stats.ev.perNation": "Réparti par nation et journée",
  "stats.ev.noData": "Pas de données pour cette stat.",
  "stats.ev.cellHint": "Voir l'évolution",
} as const;

export type Catalog = typeof fr;
export default fr;
